<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <!--        <div v-if="$gate.isUser()">-->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item">
                                <a href="/home">Home</a>
                            </li>
                            <li class="breadcrumb-item active">
                                {{ $route.meta.title }}
                            </li>
                        </ol>
                    </div>
                </div>
            </div>
            <!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br />
            <br />
            <div class="col-lg-12">
                <div class="card card-danger card-outline collapsed-card">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                            <button
                                type="button"
                                class="btn btn-tool btn-danger"
                                data-card-widget="collapse"
                            >
                                <i class="fas fa-minus"></i> Show/Hide
                            </button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Category:</span
                                        >
                                        <v-select
                                            v-model="filters.item_category"
                                            :options="linkages"
                                            label="category_name"
                                            :reduce="
                                                (linkages) =>
                                                    linkages.category_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Branch:</span
                                        >
                                        <v-select
                                            v-model="filters.branch"
                                            class="form-control"
                                            type="text"
                                            label="fullname"
                                            :options="branches"
                                            :reduce="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                            name="branch"
                                            placeholder="Select Branch"
                                            :value="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Month:</span
                                        >
                                        <select
                                            class="form-control"
                                            v-model="filters.month"
                                        >
                                            <option value="1">January</option>
                                            <option value="2">February</option>
                                            <option value="3">March</option>
                                            <option value="4">April</option>
                                            <option value="5">May</option>
                                            <option value="6">June</option>
                                            <option value="7">July</option>
                                            <option value="8">August</option>
                                            <option value="9">September</option>
                                            <option value="10">October</option>
                                            <option value="11">November</option>
                                            <option value="12">December</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Year:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter a valid year"
                                            v-model="filters.year"
                                            type="number"
                                            @input="getDailyUserTargets()"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Brands:</span
                                        >
                                        <v-select
                                            v-model="filters.brand"
                                            class="form-control"
                                            type="text"
                                            label="brand_name"
                                            :options="brands"
                                            :reduce="
                                                (brands) => brands.brand_name
                                            "
                                            name="brand"
                                            placeholder="Select Brand"
                                            :value="
                                                (brands) => brands.brand_name
                                            "
                                        ></v-select>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Category:</span
                                        >
                                        <input
                                            class="form-control"
                                            placeholder="Enter item category"
                                            v-model="filters.itemcategory"
                                            type="text"
                                        />
                                    </div>
                                </div>

                                <!--                                <div class="col-sm-4">-->
                                <!--                                    <div class="form-group">-->
                                <!--                                        <span-->
                                <!--                                            class="right badge badge-secondary"-->
                                <!--                                            >Created By:</span-->
                                <!--                                        >-->
                                <!--                                        <v-select-->
                                <!--                                            v-model="filters.created_by"-->
                                <!--                                            :options="salesmen"-->
                                <!--                                            label="user_detail"-->
                                <!--                                            :reduce="(salesmen) => salesmen.id"-->
                                <!--                                        ></v-select>-->
                                <!--                                    </div>-->
                                <!--                                </div>-->
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-primary"
                                            style="width: 100% !important"
                                            @click="
                                                getDailyUserTargets(
                                                    '/api/getAllDailyUserTargets'
                                                )
                                            "
                                        >
                                            Search
                                        </button>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button
                                            class="btn btn-danger"
                                            style="width: 100% !important"
                                            @click="reset"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br /><br />

            <div class="col-md-12">
                <div class="card card-primay card-outline">
                    <div class="card-header">
                        <div class="card-tools">
                            <!--                        &lt;!&ndash; Collapse Button &ndash;&gt;-->
                            <button
                                class="btn btn-secondary"
                                @click="copyTable"
                            >
                                <i class="fas fa-copy"></i> Copy Full Table
                            </button>
                        </div>
                    </div>
                    <div class="card-body overflow-auto">
                        <table
                            class="table table-hover table-striped table-bordered"
                        >
                            <thead>
                                <tr>
                                    <th>BRANCH</th>
                                    <th>USERID</th>
                                    <th>EMP_ID</th>
                                    <th>NAME</th>
                                    <th>DESIGNATION</th>
                                    <th>LEAD_OR_EARN</th>
                                    <th>ITEM_CATEGORY</th>
                                    <th>BRAND</th>
                                    <th>MONTH</th>
                                    <!--                                    <th>YEAR</th>-->
                                    <th>TARGET_TYPE</th>
                                    <th>TOTAL_INCENTIVE_AMOUNT</th>
                                    <th>TOTAL_MONTHLY_TARGET</th>
                                    <th>TOTAL_WORKING_DAYS</th>

                                    <th
                                        v-for="day in parseInt(numberOfDays)"
                                        :key="day"
                                    >
                                        {{ day }}
                                    </th>
                                    <th>PER DAY INCENTIVE</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="j in data" class="badge-warning">
                                    <td>{{ j.branch }}</td>
                                    <td>{{ j.user_id }}</td>
                                    <td>{{ j.emp_id }}</td>
                                    <td>{{ j.name }}</td>
                                    <td>{{ j.user.user_type }}</td>
                                    <td>{{ j.lead_or_earn }}</td>
                                    <td>{{ j.item_category }}</td>
                                    <td>{{ j.brand }}</td>
                                    <td>{{ j.month }}</td>
                                    <!--                                    <td>{{ j.year }}</td>-->
                                    <td>{{ j.target_type }}</td>
                                    <td>{{ j.total_incentive_amount }}</td>
                                    <td>{{ j.total_monthly_target }}</td>
                                    <td>{{ j.total_working_days }}</td>
                                    <td
                                        v-for="day in parseInt(numberOfDays)"
                                        :key="day"
                                    >
                                        {{ j[day] || 0 }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="card-footer">
                        <pagination
                            :pagination="pagination"
                            @prev="getDailyUserTargets(pagination.prevPageUrl)"
                            @next="getDailyUserTargets(pagination.nextPageUrl)"
                        ></pagination>
                    </div>
                </div>
            </div>
            <!-- row end -->
        </section>
        <!-- /.content -->

        <div class="modal" tabindex="-1" role="dialog" id="uploadModal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Daily User Target Import Wizard
                        </h5>
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div
                            :class="[
                                'form-group',
                                errors.link ? 'has-error' : '',
                            ]"
                        >
                            <label for="file">Excel File</label>
                            <input
                                class="form-control"
                                id="file"
                                type="file"
                                ref="file"
                                name="link"
                                placeholder="Upload Excel"
                                @change="addFile"
                            />
                            <span
                                v-if="errors.link"
                                :class="['badge bg-danger']"
                                >Please add an excel file.</span
                            >
                        </div>
                    </div>
                    <div class="card-footer">
                        <button class="btn btn-primary" @click="uploadFile">
                            Submit
                        </button>
                        <button class="btn btn-secondary" data-dismiss="modal">
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <loading :show="lshow" :label="llabel"> </loading>
        <!-- All VUE Parts end before this comment -->
        <!--        </div>-->
        <!--        <div v-if="!$gate.isUser()">-->
        <!--             <access-denied></access-denied>-->
        <!--        </div>-->
    </div>
</template>

<script>
import Pagination from "../../pagination.vue";
import { parse } from "postcss";
import loading from "vue-full-loading";

export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: { loading, pagination: Pagination },

    created() {
        this.fromdate = new Date().toISOString().slice(0, 10);
        this.todate = new Date().toISOString().slice(0, 10);
        this.params.branch = window.user.branch;
        this.getDailyUserTargets();
        this.getBranches();
        this.getSalesmen();
        this.getLinkages();
        this.getBrandsList();
        this.getCompanies();
    },

    data() {
        return {
            months: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December",
            ],
            receipts: [],
            companies: [],
            branches: [],
            saleorders: [],
            salesmen: [],
            invoices: [],
            medias: [],
            linkages: [],
            company: "",
            branch: "",
            fromdate: "",
            todate: "",
            upload_status: "Pending",
            params: new Form({
                item_category: null,
                month: null,
                branch: null,
                target_type: null,
                activity_type: "SALES",
            }),
            filters: new Form({
                id: "",
                itemdivision: "",
                item_category: "",
                salesperson: "",
                brand: "",
                branch: "",
                month: "",
                year: "",
                results: "",
                created_by: "",
            }),
            lshow: false,
            llabel: "Syncing. Do not close or change this page...",
            file: "",
            link: "",
            status: "",
            count: "",
            lsi_id: "",
            data: null,
            selectedItemId: "",
            selectedValidity: "",
            branchIncentives: [],
            partyIncentives: [],
            errors: [],
            generated_data: [],
            brands: [],
            numberOfDays: "31",
            pagination: {
                lastPage: "",
                currentPage: "",
                total: "",
                lastPageUrl: "",
                nextPageUrl: "",
                prevPageUrl: "",
                from: "",
                to: "",
            },
        };
    },

    methods: {
        reset() {
            this.filters.reset();
            this.getDailyUserTargets();
            this.getBranches();
            this.getSalesmen();
            this.getLinkages();
            this.getBrandsList();
            this.getCompanies();
        },
        getCompanies() {
            axios.post("/api/getCompanies").then((response) => {
                this.companies = response.data;
            });
        },
        getBranches() {
            axios.post("/api/getSAPBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getLinkages(url = "/api/getActiveCategoryProductLinks") {
            axios.post(url).then((response) => {
                this.linkages = response.data.data;
            });
        },

        getBrandsList() {
            axios.post("/api/getMasterBrandsList").then((response) => {
                this.brands = response.data;
            });
        },

        getSalesmen() {
            axios.post("/api/getBranchCallAgents").then((response) => {
                this.salesmen = response.data;
            });
        },
        getTemplate() {
            axios({
                url: "/api/getDailyUserTargetsTemplateExport",
                data: { params: this.params },
                method: "post",
                responseType: "blob",
            }).then((response) => {
                toast.fire({
                    icon: "success",
                    title: "Template Generated",
                });
                var blob = new Blob([response.data], {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                });
                saveAs(response.data, "incentive_rules_template.xlsx");
            });
        },

        openValidityModal(itemId, currentValidity) {
            this.selectedItemId = itemId;
            this.selectedValidity = currentValidity;
            // Additional logic to show/hide the modal as needed
            // You may use a library like BootstrapVue for modals
            $("#validityModal").modal("show");
        },

        openBranchesModal(branchData) {
            this.branchIncentives = branchData;
            // Additional logic to show/hide the modal as needed
            // You may use a library like BootstrapVue for modals
            $("#multiBranchModal").modal("show");
        },

        openPartiesModal(partyData) {
            this.partyIncentives = partyData;
            // Additional logic to show/hide the modal as needed
            // You may use a library like BootstrapVue for modals
            $("#multiPartyModal").modal("show");
        },

        saveValidityChanges() {
            // Add logic to update the validity in your data or make an API call
            // You can use this.selectedItemId and this.selectedValidity to get the selected item and its new validity
            // Close the modal after saving
            $("#validityModal").modal("hide");
        },

        uploadPrompt() {
            $("#uploadModal").modal("show");
        },

        generatePrompt() {
            $("#generateModal").modal("show");
        },

        addFile() {
            this.file = this.$refs.file.files[0];
            this.link = this.file;
        },

        uploadFile() {
            var formData = new FormData();
            formData.append("file", this.link);
            toast.fire({
                icon: "warning",
                title: "Wait For Syncing to be Over",
            });
            this.lshow = true;
            axios({
                method: "post",
                url: "/api/postDailyUserTargetsTemplateImport",
                data: formData,
                headers: { "Content-Type": "multipart/form-data" },
            })
                .then((response) => {
                    this.data = response.data;
                    toast.fire({
                        type: "success",
                        title: "File Analyzed",
                    });
                    this.errors = [];
                    this.lshow = false;
                    this.status = response.data.Status;
                    this.count = response.data.Count;
                    this.lsi_id = response.data.Data;
                    this.upload_status = "Complete";
                    $("#uploadModal").modal("hide");
                    this.getDailyUserTargets();
                })
                .catch((error) => {
                    this.lshow = false;
                    toast.fire({
                        type: "error",
                        title: "Syncing Failed",
                    });
                    this.errors = error.response.data.errors;
                });
            this.lshow = false;
        },

        copyTable() {
            // const table = document.querySelector(".table");
            // const range = document.createRange();
            // // Clone the table so that you can modify the cloned table without affecting the original
            // const clonedTable = table.cloneNode(true);
            // // Exclude the second column (index 1) from the cloned table
            // clonedTable.querySelectorAll("tr").forEach((row) => {
            //     const cells = Array.from(row.cells);
            //     cells[44].remove(); // Exclude the second column (index 1)
            // });
            // range.selectNode(clonedTable);
            // const selection = window.getSelection();
            // selection.removeAllRanges();
            // selection.addRange(range);
            //
            // document.execCommand("copy");
            //
            // selection.removeAllRanges();
            //
            // alert(
            //     "Table content (excluding second column) copied to clipboard!"
            // );

            const table = document.querySelector(".table"); // Select the table element using its class
            const range = document.createRange();
            range.selectNode(table);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand("copy");
            selection.removeAllRanges();

            alert("Table content copied to clipboard!");
        },

        getDailyUserTargets(url = "/api/getAllDailyUserTargets") {
            axios.post(url, { filters: this.filters }).then((response) => {
                this.data = response.data.data;
                this.configPagination(response.data);
                // this.getNumberOfDays();
            });
        },

        // getNumberOfDays() {
        //     const currentYear = new Date().getFullYear();
        //     const year = parseInt(currentYear, 10);
        //     const month = parseInt(this.data.month, 10);
        //
        //     if (year && month >= 1 && month <= 12) {
        //         const lastDayOfMonth = new Date(year, month, 0).getDate();
        //         this.numberOfDays = lastDayOfMonth;
        //     } else {
        //         this.numberOfDays = "31";
        //     }
        // },

        configPagination(data) {
            this.pagination.lastPage = data.lastPage;
            this.pagination.currentPage = data.current_page;
            this.pagination.total = data.total;
            this.pagination.lastPageUrl = data.last_page_url;
            this.pagination.nextPageUrl = data.next_page_url;
            this.pagination.prevPageUrl = data.prev_page_url;
            this.pagination.from = data.from;
            this.pagination.to = data.to;
        },
    },
};
</script>
